module.exports = __webpack_public_path__ + "static/media/tdh.acb7724d.jpg";